import {useDebugValue} from 'react';

import {undef} from '../../../utils/undef';

import {useSettings} from './useSettings';

const defaultMediaSettings = {
    width: undef,
    height: undef,
    isMobile: undef,
    isTablet: undef,
    isDesktop: undef
};

function useMediaSettings(props) {
    const {
        mediaSettings: propsMediaSettings
    } = props;

    const {
        initialSettings: initialMediaSettings,
        settings: mediaSettings,
        changeSettings: changeMediaSettings
    } = useSettings(defaultMediaSettings, propsMediaSettings);

    const result = {
        initialMediaSettings,
        mediaSettings,
        changeMediaSettings
    };

    useDebugValue(result);

    return result;
}

export {useMediaSettings};
